// extracted by mini-css-extract-plugin
export default {"container":"Bl-z","bubbleNav":"Cl-z","graphic":"Dl-z","contact":"El-z"};